import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card, CardHeader, CardBody, Badge } from "reactstrap";
import {setCampaignLoader, setDynamicText, setSelectedTemplate, setTemplateCategories, setTemplateLoader} from "../../../../../../../slices/campaigns/reducer";
import { getTemplateCreatives } from '../../../../../../../slices/campaigns/thunk';
import { toggleSelectTemplateModal } from '../../../../../../../slices/modals/reducer';
import { createSelector } from 'reselect';
import { scaleElementToFitParent } from '../../../../../../../slices/helper';
import { setPreloader } from '../../../../../../../slices/layouts/reducer';


function TemplateCard({ template, category }) {
  const dispatch = useDispatch();
  const thumbnail = useRef();
  const [showInfo, setShowInfo] = useState(false);

  async function useTemplate() {
    dispatch(setCampaignLoader(true));
    dispatch(setSelectedTemplate(template));
    dispatch(toggleSelectTemplateModal());
    await dispatch(getTemplateCreatives(template._id));
    dispatch(setCampaignLoader(false));
  }

  useEffect(() => {
    if (thumbnail.current) {
      setTimeout(() => {
        scaleElementToFitParent(thumbnail.current, null, 10);
      }, 1);
      window.addEventListener('resize', () => scaleElementToFitParent(thumbnail.current, null, 10));
    }
    return () => {
      window.removeEventListener('resize', () => scaleElementToFitParent(thumbnail.current, null, 10));
    };
  }, [thumbnail]);

  return (
    <Card className='template-card hover-bg-light' style={{ transition: "0.15s", minHeight: "400px", maxHeight: "400px" }}>
      <CardHeader className='py-1 d-flex bg-transparent align-items-center justify-content-between'>
        {template.name}
        <button
          className={`btn btn-icon btn-transparent fs-16` + (showInfo ? " text-success" : "")}
          onMouseOver={() => setShowInfo(true)}
          onMouseOut={() => setShowInfo(false)}
          style={{ marginRight: "-1rem" }}>
          <i className='ri-information-line align-bottom'></i>
        </button>
      </CardHeader>
      <CardBody className='d-flex flex-column align-items-center justify-content-center position-relative'>
        <div className='w-100 flex-1 position-relative'>
          <img className='w-100 h-auto' src={template.thumbnail} ref={thumbnail} draggable="false" />
          {showInfo ?
            <div className='template-card-info overflow-hidden'>
              <div className='w-100 d-flex'>
                <b className='me-1'>Category:</b>
                <p>{(category || '')}</p>
              </div>
              <div className='w-100 d-flex flex-wrap gap-1'>
                <b style={{ lineHeight: "24.5px" }}>Available Sizes:</b>
                {(template.sizes || []).map((item, idx) =>
                  <span className='d-flex align-items-center justify-content-center fs-11 bg-primary text-white'
                    style={{ padding: "4px 14px", borderRadius: "8px" }}
                    key={idx}>
                    {item}
                  </span>
                )}
              </div>
            </div>
            : null}
        </div>
        <button className='btn btn-light btn-light-hover-success w-100 mt-3' onClick={useTemplate}>Use Template</button>
      </CardBody>
    </Card>
  )
}

export default TemplateCard
